import { api } from '../core';
import { DateInfo, PageLabel, TextLabel } from './getBundle';

export interface PageInfoData {
  bookmarkDate: string | null;
  clusterDate: string;
  chronologyEntryIds?: string[] | null;
  dates: DateInfo[];
  highRelevance: boolean;
  inLightBundle: boolean;
  pageLabels: PageLabel[];
  textLabels: TextLabel[];
}

export interface BundlePageInfoResponse {
  pageInfo: Record<string, PageInfoData>;
}

type GetBundlePageInfoProps = {
  bundleId: string;
  pageIds: string[];
  abortController?: AbortController;
};

export const getBundlePageInfoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundlePageInfo: builder.query<BundlePageInfoResponse, GetBundlePageInfoProps>({
      query: ({ bundleId, pageIds, abortController = new AbortController() }: GetBundlePageInfoProps) => ({
        url: `bundle/page-info`,
        method: 'GET',
        params: {
          bundleId: bundleId,
          pageIds: pageIds.join(','),
        },
        signal: abortController.signal,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getBundlePageInfo in onQueryStarted:', error);
          }
        }
      },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundlePageInfoQuery } = getBundlePageInfoApi;
